import { render, staticRenderFns } from "./fixRecord.vue?vue&type=template&id=55e7db1c&scoped=true&"
import script from "./fixRecord.vue?vue&type=script&lang=js&"
export * from "./fixRecord.vue?vue&type=script&lang=js&"
import style0 from "./fixRecord.vue?vue&type=style&index=0&id=55e7db1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e7db1c",
  null
  
)

export default component.exports